import {
  
    UPDATE_ITEM,
    SET_PROJECT,
    SET_MY_PROJECT,
    SET_TDK_PROJECT,
    SET_SELECTED_PROJECT
} from "constants/ActionTypes";
import { getLocalStorageJson } from "util/utilFunction";

const INIT_STATE = {
    item: null,
    isUpdate: false,
    myProjects: getLocalStorageJson("myProject", []),
    projects: getLocalStorageJson("projects", []),
    TDKprojects: getLocalStorageJson("TDKprojects", []),
    selectedProject: getLocalStorageJson("selectedProject", null),
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case UPDATE_ITEM: {
            return {
                ...state,
                item: action.payload.item,
                isUpdate: action.payload.isUpdate,
            }
        }
        case SET_PROJECT: {
            localStorage.setItem("projects",JSON.stringify(action.payload.projects));

            return {
                ...state,
                projects: action.payload.projects,
            }
        }
        case SET_MY_PROJECT: {
            localStorage.setItem("myProject",JSON.stringify(action.payload.myProjects));
            return {
                ...state,
                myProjects: action.payload.myProjects,
            }
        }
        case SET_TDK_PROJECT: {
            localStorage.setItem("TDKprojects",JSON.stringify(action.payload.projects));
            return {
                ...state,
                TDKprojects: action.payload.projects,
            }
        }
        case SET_SELECTED_PROJECT: {
            localStorage.setItem("selectedProject",JSON.stringify(action.payload.selectedProject));
            return {
                ...state,
                selectedProject: action.payload.selectedProject,
            }
        }
 
        default:
            return state;
    }
}
